import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/auth';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        try {
            const token = localStorage.getItem('admin_token');
            const savedUser = localStorage.getItem('admin_user');

            if (token && savedUser) {
                // Token verify etmeyi dene, başarısız olursa logout yap
                try {
                    const response = await authService.verifyToken();

                    if (response.success && response.data.user.isAdmin) {
                        setUser(response.data.user);
                    } else {
                        logout();
                    }
                } catch (verifyError) {
                    console.error('❌ Token verify error:', verifyError);
                    logout();
                }
            } else {
                setUser(null);
            }
        } catch (error) {
            console.error('❌ Auth check failed:', error);
            logout();
        } finally {
            setLoading(false);
        }
    };

    // src/contexts/AuthContext.js - login fonksiyonunu güncelle
    const login = async (email, password) => {
        try {
            const response = await authService.login(email, password);

            if (response.success && response.data.user.isAdmin) {
                localStorage.setItem('admin_token', response.data.token);
                localStorage.setItem('admin_user', JSON.stringify(response.data.user));
                setUser(response.data.user);

                // Sayfayı yeniden yükle - bu işe yarayacak
                window.location.href = '/';
                return { success: true };
            } else {
                return {
                    success: false,
                    message: 'Bu email adresi admin yetkisine sahip değil'
                };
            }
        } catch (error) {
            console.error('❌ Login error:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Giriş başarısız'
            };
        }
    };

    const logout = () => {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        setUser(null);
        // Sayfayı login'e yönlendir
        window.location.href = '/login';
    };

    const value = {
        user,
        login,
        logout,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};